import React, { createContext, useState, useContext } from "react";
// import { createCategory, updateCategory, deleteCategory, getCategory } from "../services/categoryService";
// import { getCategory } from "@/lib/firebase/category/read";
// import { createNewCategory, deleteCategory, updateCategory } from "@/lib/firebase/category/write";

import { getCategory } from "../../../../lib/firebase/category/read";
import { createNewCategory, deleteCategory, updateCategory } from "../../../../lib/firebase/category/write";
import { useNavigate } from "react-router-dom";

const CategoryFormContext = createContext();

export function useCategoryForm() {
  return useContext(CategoryFormContext);
}

export default function CategoryFormContextProvider({ children }) {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isDone, setIsDone] = useState(false);
  const [image, setImage] = useState(null);
  const navigate = useNavigate();

  const handleData = (key, value) => {
    setIsDone(false);
    setData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };

  const handleCreate = async () => {
    setError(null);
    setIsLoading(true);
    setIsDone(false);
    try {
      await createNewCategory({ data, image });
      setIsDone(true);
      navigate("/admin/categories");
    } catch (error) {
      setError(error?.message);
    }
    setIsLoading(false);
  };

  const handleUpdate = async (id) => {
    setError(null);
    setIsLoading(true);
    setIsDone(false);
    try {
      await updateCategory({ id, data, image });
      setIsDone(true);
      navigate("/admin/categories");
    } catch (error) {
      setError(error?.message);
    }
    setIsLoading(false);
  };

  const handleDelete = async (id) => {
    setError(null);
    setIsLoading(true);
    setIsDone(false);
    try {
      await deleteCategory(id);
      setIsDone(true);
      navigate("/admin/categories");
    } catch (error) {
      setError(error?.message);
    }
    setIsLoading(false);
  };

  const fetchData = async (id) => {
    setError(null);
    setIsLoading(true);
    setIsDone(false);
    try {
      const res = await getCategory(id);
      if (res.exists()) {
        setData(res.data());
      } else {
        throw new Error(`No category found for id ${id}`);
      }
    } catch (error) {
      setError(error?.message);
    }
    setIsLoading(false);
  };

  return (
    <CategoryFormContext.Provider value={{ data, handleData, isLoading, error, isDone, handleCreate, handleUpdate, handleDelete, fetchData, image, setImage }}>
      {children}
    </CategoryFormContext.Provider>
  );
}
